import React from 'react'
import dlv from 'dlv'
import startCase from 'to-start-case'
import { isPlainObject } from 'tiny-compose-fns'

import { Box, Flex, Text, Grid } from 'system'
import { Heading } from './Heading'

const Color = ({ color, number }) => (
  <Flex flexDirection="column" alignItems="center" justifySelf="start">
    <Box
      border="1px solid"
      borderColor={color === '#fff' ? 'gray.70' : color}
      borderRadius="50%"
      bg={color}
      width={['3rem', '5rem']}
      height={['3rem', '5rem']}
      mb={1}
    />
    <Text textAlign="center" color="gray.20">
      {number && (
        <Text as="strong" fontWeight="bold" fontSize="midMedium">
          {number}
        </Text>
      )}
      <Text fontSize="tiny">{color.toUpperCase()}</Text>
    </Text>
  </Flex>
)

export const ColorSwatches = ({ theme }) => {
  const colorEntries = Object.entries(dlv(theme, 'colors', {}))

  return (
    <Grid
      gridTemplateColumns={['repeat(auto-fit, 3rem)', 'repeat(6, 1fr)']}
      gridColumnGap={4}
      gridRowGap={3}
      justifyContent="center"
    >
      {colorEntries.map(([name, colors]) => (
        <>
          <Heading as="h3" gridColumn="1 / -1" fontSize="medium">
            {startCase(name)}
          </Heading>

          {isPlainObject(colors) ? (
            Object.entries(colors).map(([i, color]) => (
              <Color key={color} number={i} color={color} />
            ))
          ) : (
            <Color key={colors} color={colors} />
          )}
        </>
      ))}
    </Grid>
  )
}

export default ColorSwatches
